var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"main-content"},[_vm._v(" "+_vm._s(_vm.content.content)+" ")]),(_vm.content.imgs && _vm.content.imgs.length>0)?_c('img-list',{attrs:{"imgs":_vm.content.imgs}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }